import { Flex } from '@chakra-ui/react';
import DashboardFilters from './components/DashboardFilters';
import React, { useCallback } from 'react';
import TransactionBarChart from './components/TransactionBarChart';
import {
  DashboardTransacFiltersQueryParams,
  useDashboardTransactionFilters,
} from './hook/useDashboardTransactionFilters';
import DashboardDonutChart from './components/DashboardDonutChart';

const Dashboard = () => {
  const { search, queryParams } = useDashboardTransactionFilters();

  const handleUpdate = useCallback((value: string | undefined, key: keyof DashboardTransacFiltersQueryParams) => {
    if (value === 'all') {
      search(key, undefined);
      return;
    }
    search(key, value);
  }, [search]);


  return (
    <>
      <DashboardFilters marginBottom="l" onUpdateFilters={handleUpdate} queryParams={queryParams} />

      <Flex width="full" direction={{
        base: 'column',
        lg: 'row'
      }}>
        <Flex direction="column" width={{ base: '100%',md: '35%', lg: '30%'}}>
          {/* <CardLastSettlement mr="l" />
          <CardNextSettlement mr="l" mt="l"/> */}
          <TransactionBarChart idMerchant={queryParams.idMerchant} idBranch={queryParams.idBranch} margin="l"/>
        </Flex>

        <Flex flex="1">
          <DashboardDonutChart queryParams={queryParams} />
        </Flex>
      </Flex>
    </>
  );
};

export default Dashboard;
